<template>
  <div class="aboutGmat">
       <headers class="herderNav" ref="header" :isChange="false"/>
    <div class="aboutGmatCon">
		<div class="suspension">
			<div class="aboutGmatConLeft">
			  <el-row class="tac">
			    <el-col :span="24">
			        <h2 class="tits">关于GMAT</h2>
			        <el-menu default-active="2" class="el-menu-vertical-demo" active-text-color="#5B7CFF" :unique-opened="true" router>
			        <el-menu-item :index="'/introduction'"><span slot="title">考试入门介绍</span></el-menu-item>
			        <el-submenu index="1">
			          <template slot="title"><span>各科学习指南</span></template>
			          <el-menu-item-group >
			            <el-menu-item :index="'/matsList'">数学</el-menu-item>
			            <el-menu-item :index="'/logicalList'">逻辑</el-menu-item>
			            <el-menu-item :index="'/grammarList'">语法</el-menu-item>
			            <el-menu-item :index="'/readList'">阅读</el-menu-item>
			          </el-menu-item-group>
			        </el-submenu>
			        <el-menu-item :index="'/hightScore'"><span slot="title">高分学员分享</span></el-menu-item>
			        <el-menu-item :index="'/mostData'"><span slot="title">最强王炸资料</span></el-menu-item>
			      </el-menu>
			    </el-col>
			  </el-row>
			</div>
		</div>

     <!-- 右侧 -->
      <div class="aboutGmatConRight">
        <!-- 公共部分 -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import headers from '../../components/header.vue'
  import searchNav from '../../components/searchNav.vue'
  export default {
    components: {
      headers,
      searchNav
    },
    mounted() {
      this.$refs.header.isTop=false
      this.$refs.header.headerBack.background = '#ffffff';
      this.$refs.header.herderTits.color = '#666666';
      this.$refs.header.headerIcon = require('@/assets/home/headerNav.png');
      this.$refs.header.loginButton = {
         background : '#618aff',
         color:'#fff'
      }
      this.$refs.header.phoneButton = {
      color:'#618aff',
      border: '1px solid #618aff'
       }
      // api.baseParams().then(res => {
      //   console.log(res)
      // })
    },
    data() {
      return {
        navCodes:require('@/assets/login/whiteCode.png'),
        headerIcon:require('@/assets/bottom/bottomIcon.png'),
      }
    },
    methods: {
      goSearch(){
        this.$router.push("/searchMatter")
      }
    }
  }
</script>

<style scoped>
  @import url("../../assets/css/aboutGmat.css");
</style>



// WEBPACK FOOTER //
// src/view/opporTunity/aboutGmat.vue